import { ArrowIcon, EditIcon } from "assets/icons";
import { If } from "components";
import { isLastIndexOfArray } from "helpers";
import { ApiResponse } from "libs/api";
import { Category } from "modules/categories";
import { Fragment, useMemo } from "react";
import { createSearchParams, useNavigate, useParams } from "react-router-dom";

import { CategoriesBreadCrumbsProps } from "./CategoriesBreadCrumbs.types";

import styles from "./CategoriesBreadCrumbs.module.scss";

const CategoriesBreadCrumbs = ({ category }: CategoriesBreadCrumbsProps) => {
  const navigate = useNavigate();

  const { editableProductId, productId } = useParams();

  const categoriesChain = useMemo(() => {
    const result: Array<Category | ApiResponse<Category>> = [category];

    let curentCategory: Category = category as Category;

    while (curentCategory.parentCategory) {
      result.unshift(curentCategory.parentCategory);
      curentCategory = curentCategory.parentCategory;
    }

    return result;
  }, [category]);

  const handleChangeCategotyClick = () => {
    const mainCategoryId = categoriesChain[0].id;
    const subCategoryId = categoriesChain[1].id;
    const subChildCategoryId = categoriesChain[2].id;

    navigate({
      pathname: "/products/category",
      search: createSearchParams({
        "main-category": mainCategoryId,
        "sub-category": subCategoryId,
        "sub-child-category": subChildCategoryId
      }).toString()
    });
  };

  return (
    <div className={styles.breadCrumbs}>
      {categoriesChain.map((chainCategory, index) => (
        <Fragment key={chainCategory.id}>
          <div>{chainCategory.name} </div>

          <If
            condition={
              isLastIndexOfArray(index, categoriesChain) &&
              !(editableProductId ?? productId)
            }
          >
            <button
              className={styles.breadCrumbs_editButton}
              onClick={handleChangeCategotyClick}
            >
              <EditIcon width={20} height={20} color={"#FB3973"} />
            </button>
          </If>

          <If condition={!isLastIndexOfArray(index, categoriesChain)}>
            <div className={styles.breadCrumbs_arrowIcon}>
              <ArrowIcon width={20} height={20} color={"#A8A8BB"} />
            </div>
          </If>
        </Fragment>
      ))}
    </div>
  );
};

export default CategoriesBreadCrumbs;
